import type ClientOAuth2 from 'client-oauth2';
import { type ApiSuccessResponse, type ApiService } from '../types/ApiService';

export const auth = (siteApi: ApiService) => ({
  postToken: (
    username: string,
    password: string,
  ): Promise<ClientOAuth2.Data> => {
    return siteApi.post('/auth/token', {
      username,
      password,
      grant_type: 'password',
      client_id: 'relcore-site',
    });
  },
  password: {
    put: (
      currentPassword: string,
      newPassword: string,
    ): Promise<ApiSuccessResponse<void>> => {
      return siteApi.put('/auth/password', {
        currentPassword,
        newPassword,
      });
    },
  },
});
